import { DEFAULT_SIGN_IN_PATH, DEFAULT_SIGN_OUT_PATH } from 'authentication-data';
import { AuthenticationFeatureRoutesConfig } from './AuthenticationFeatureRoutesConfig';

export const defaultAuthenticationFeatureRoutesConfig: AuthenticationFeatureRoutesConfig = {
  signInPath: DEFAULT_SIGN_IN_PATH,
  signOutPath: DEFAULT_SIGN_OUT_PATH,
};
